import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { AppProvider } from "./context/AppContext";
import Home from "./components/Home";
import Maintenance from "./components/pages/Maintenance";
import AboutUs from "./components/pages/AboutUs";
import FindDoctors from "./components/pages/FindDoctors";
import OurHospitals from "./components/pages/OurHospitals";
import ContactUs from "./components/pages/ContactUs";
// import HealthBlog from "./components/pages/HealthBlog";
// import PatientStories from "./components/pages/PatientStories";
import SpecialtyPage from "./components/pages/SpecialtyPage";
import OphthalmologyIndex from "./components/pages/OphthalmologyIndex";
import OphthalmologyPage from "./components/pages/OphthalmologyPage";
import DoctorProfile from "./components/pages/DoctorProfile";
import HospitalDetails from "./components/pages/HospitalDetails";
import BlogPost from "./components/pages/BlogPost";
import GallStone from "./components/pages/GallStone";
import KidneyStone from "./components/pages/KidneyStone";
import Piles from "./components/pages/Piles";
import Circumcision from "./components/pages/Circumcision";
import Hernia from "./components/pages/Hernia";

// Admin Components
import {
  AdminDashboard,
  AdminDoctorsList,
  AdminClinicsList,
  AdminBookings,
  AdminDoctorCreate,
  AdminDoctorEdit,
  AdminDoctorView,
  AdminClinicCreate,
  AdminLogin,
  AdminForgotPassword
} from "./components/pages/admin";
import AdminClinicView from "./components/pages/admin/clinics/view";
import AdminClinicEdit from "./components/pages/admin/clinics/edit";

import { Toaster } from "./components/ui/sonner";
import AutoBookingModal from "./components/AutoBookingModal";

function App() {
  return (
    <HelmetProvider>
      <AppProvider>
        <div className="App">
          <BrowserRouter>
        <Routes>
          {/* <Route path="/" element={<Maintenance />} /> */}
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/find-doctors" element={<FindDoctors />} />
          <Route path="/hospitals" element={<OurHospitals />} />
          <Route path="/contact" element={<ContactUs />} />
          {/* <Route path="/blog" element={<HealthBlog />} /> */}
          {/* <Route path="/patient-stories" element={<PatientStories />} /> */}
          <Route path="/specialty/:specialtyName" element={<SpecialtyPage />} />
          <Route path="/ophthalmology" element={<OphthalmologyIndex />} />
          <Route path="/ophthalmology/:diseaseName" element={<OphthalmologyPage />} />
          <Route path="/gall-stone" element={<GallStone />} />
          <Route path="/kidney-stone" element={<KidneyStone />} />
          <Route path="/piles" element={<Piles />} />
          <Route path="/circumcision" element={<Circumcision />} />
          <Route path="/hernia" element={<Hernia />} />
          <Route path="/doctor/:doctorId" element={<DoctorProfile />} />
          <Route path="/hospital/:hospitalId" element={<HospitalDetails />} />
          <Route path="/blog/:postId" element={<BlogPost />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/doctors" element={<AdminDoctorsList />} />
          <Route path="/admin/doctors/create" element={<AdminDoctorCreate />} />
          <Route path="/admin/doctors/:doctorId" element={<AdminDoctorView />} />
          <Route path="/admin/doctors/:doctorId/edit" element={<AdminDoctorEdit />} />
          <Route path="/admin/clinics" element={<AdminClinicsList />} />
          <Route path="/admin/clinics/create" element={<AdminClinicCreate />} />
          <Route path="/admin/clinics/:clinicId" element={<AdminClinicView />} />
          <Route path="/admin/clinics/:clinicId/edit" element={<AdminClinicEdit />} />
          <Route path="/admin/bookings" element={<AdminBookings />} />
        </Routes>
          </BrowserRouter>
          <Toaster />
          <AutoBookingModal />
        </div>
      </AppProvider>
    </HelmetProvider>
  );
}

export default App;